export const COOKIES_CONSTANT = {
    TOKEN: "access_token",
  }
  